(function () {
  const roots = document.querySelectorAll('[data-aw-slideshow]');

  roots.forEach((root) => {
    if (root.dataset.awSlideshowInitialized === 'true') return;
    root.dataset.awSlideshowInitialized = 'true';

    const viewport = root.querySelector('[data-aw-slideshow-viewport]');
    const track = root.querySelector('[data-aw-slideshow-track]');
    const originalSlides = Array.from(root.querySelectorAll('[data-aw-slideshow-slide]'));
    const previousButton = root.querySelector('[data-aw-slideshow-prev]');
    const nextButton = root.querySelector('[data-aw-slideshow-next]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const autoplayInterval = Number(root.dataset.autoplayInterval) || 5000;
    let currentIndex = 1;
    let autoplayTimer;
    let paused = false;
    let scrollFrame;
    let normalizeTimer;

    if (!viewport || !track || originalSlides.length < 2) return;

    const lastClone = originalSlides[originalSlides.length - 1].cloneNode(true);
    const firstClone = originalSlides[0].cloneNode(true);
    lastClone.setAttribute('aria-hidden', 'true');
    firstClone.setAttribute('aria-hidden', 'true');
    track.prepend(lastClone);
    track.append(firstClone);

    const slides = Array.from(root.querySelectorAll('[data-aw-slideshow-slide]'));
    const slideCount = originalSlides.length;

    const getNearestIndex = () => {
      let nearestIndex = 0;
      let nearestDistance = Number.POSITIVE_INFINITY;
      slides.forEach((slide, index) => {
        const distance = Math.abs(viewport.scrollLeft - slide.offsetLeft);
        if (distance < nearestDistance) {
          nearestDistance = distance;
          nearestIndex = index;
        }
      });
      return nearestIndex;
    };

    const normalizeLoop = () => {
      if (currentIndex === 0) {
        currentIndex = slideCount;
        viewport.scrollTo({ left: slides[currentIndex].offsetLeft, behavior: 'auto' });
      } else if (currentIndex === slides.length - 1) {
        currentIndex = 1;
        viewport.scrollTo({ left: slides[currentIndex].offsetLeft, behavior: 'auto' });
      }
    };

    const updateIndex = () => {
      currentIndex = getNearestIndex();
      if (currentIndex === 0 || currentIndex === slides.length - 1) {
        window.clearTimeout(normalizeTimer);
        normalizeTimer = window.setTimeout(normalizeLoop, 350);
      }
    };

    const goTo = (index) => {
      let targetIndex;
      if (index === slideCount) {
        targetIndex = slides.length - 1;
      } else if (index === -1) {
        targetIndex = 0;
      } else {
        targetIndex = ((index % slideCount) + slideCount) % slideCount + 1;
      }
      currentIndex = targetIndex;
      viewport.scrollTo({
        left: slides[targetIndex].offsetLeft,
        behavior: reducedMotion.matches ? 'auto' : 'smooth'
      });
    };

    const stopAutoplay = () => {
      window.clearInterval(autoplayTimer);
      autoplayTimer = undefined;
    };

    const startAutoplay = () => {
      stopAutoplay();
      if (paused || reducedMotion.matches || document.hidden) return;
      autoplayTimer = window.setInterval(() => goTo(currentIndex), autoplayInterval);
    };

    const pause = () => {
      paused = true;
      stopAutoplay();
    };

    const resume = () => {
      paused = false;
      startAutoplay();
    };

    previousButton?.addEventListener('click', () => goTo(currentIndex - 2));
    nextButton?.addEventListener('click', () => goTo(currentIndex));
    viewport.addEventListener('scroll', () => {
      window.cancelAnimationFrame(scrollFrame);
      scrollFrame = window.requestAnimationFrame(updateIndex);
    }, { passive: true });
    root.addEventListener('mouseenter', pause);
    root.addEventListener('mouseleave', resume);
    root.addEventListener('focusin', pause);
    root.addEventListener('focusout', (event) => {
      if (!root.contains(event.relatedTarget)) resume();
    });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stopAutoplay();
      else startAutoplay();
    });
    reducedMotion.addEventListener?.('change', startAutoplay);

    viewport.scrollTo({ left: slides[1].offsetLeft, behavior: 'auto' });
    startAutoplay();
  });
})();
